import ComponentModule from "@eisinc/Overrides/Components/CustomerAddressForm";

export * from "@eisinc/Overrides/Components/CustomerAddressForm";

export default ComponentModule;
